import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import ScrollFloat from './ScrollFloat';
import './ProblemSolution.css';

const ProblemSolution = () => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.1 });
  
  return (
    <section id="problem-solution" className="problem-solution">
      <div ref={sectionRef} className={`problem-solution-container ${isVisible ? 'animate-in' : ''}`}>
        <div className="problem-section">
          <div className="problem-content">
            <span className="section-badge problem">The Problem</span>
            <h2 className="section-title">
              <ScrollFloat speed={0.3} direction="up">Information Gaps Are Costing You</ScrollFloat>
            </h2>
            <div className="problem-list">
              <div className="problem-item">
                <div>
                  <h3>Time Wasted Searching</h3>
                  <p>Employees spend hours searching through documents, emails, and knowledge bases to find simple answers.</p>
                </div>
              </div>
              <div className="problem-item">
                <div>
                  <h3>Inconsistent Information</h3>
                  <p>Different employees give different answers, leading to confusion and mistakes.</p>
                </div>
              </div>
              <div className="problem-item">
                <div>
                  <h3>Slow Onboarding</h3>
                  <p>New employees struggle to find information, extending training time and reducing productivity.</p>
                </div>
              </div>
              <div className="problem-item">
                <div>
                  <h3>Lost Productivity</h3>
                  <p>Information gaps result in delays, errors, and decreased team efficiency.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="solution-section">
          <div className="solution-content">
            <span className="section-badge solution">Our Solution</span>
            <h2 className="section-title">
              <ScrollFloat speed={0.3} direction="up">One Intelligent Assistant for Everything</ScrollFloat>
            </h2>
            <div className="solution-list">
              <div className="solution-item">
                <div>
                  <h3>Instant Answers</h3>
                  <p>Employees get accurate, instant responses from your knowledge base in seconds.</p>
                </div>
              </div>
              <div className="solution-item">
                <div>
                  <h3>Accelerated Training</h3>
                  <p>New hires can quickly learn company policies, procedures, and best practices.</p>
                </div>
              </div>
              <div className="solution-item">
                <div>
                  <h3>Always Up-to-Date</h3>
                  <p>Automatically syncs with your knowledge base, ensuring information is always current.</p>
                </div>
              </div>
              <div className="solution-item">
                <div>
                  <h3>Measurable Results</h3>
                  <p>Track usage, identify knowledge gaps, and improve your documentation over time.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;

